import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { useMounted } from '~/hooks/useMounted';

import { orderStore, userStore } from '~/stores';

import Icon from '../../Icon/Icon';

import styles from './DeliveryButton.module.scss';

type Props = {
  expressDeliveryMessage: string;
  expressDeliveryMessageArgs: Record<string, string>;
  showFlashIcon?: boolean;
  handleDeliveryAddress: () => void;
};

export const DeliveryButton = observer(
  ({
    expressDeliveryMessage,
    expressDeliveryMessageArgs,
    handleDeliveryAddress,
  }: Props) => {
    const { t } = useTranslation();
    const mounted = useMounted();
    const etaCalculation = mounted ? orderStore.etaCalculation : null;
    const deliveryAddress = mounted ? userStore.deliveryAddress : null;

    return (
      <div
        className={classes([
          styles.header_address,
          !etaCalculation && '_active',
        ])}
        onClick={handleDeliveryAddress}
        data-company={company.name}
        data-button="header-address"
      >
        {etaCalculation && (
          <div className={styles.header_eta}>
            <div className={styles.header_eta__text}>
              {t(expressDeliveryMessage, expressDeliveryMessageArgs)}
            </div>
            <Icon type="chevron" size={16} />
          </div>
        )}
        <div
          className={styles.header_address__text}
          title={t('phrases:selectDeliveryAddress')}
        >
          {!etaCalculation || !deliveryAddress
            ? t('phrases:selectDeliveryAddress')
            : `${deliveryAddress.address1} ${deliveryAddress.zip}`}
        </div>
      </div>
    );
  },
);
